import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Icon
} from 'design-react-kit';
import { ListingLinkMore } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { SchedaPersonaModalView, getUserFoto } from 'uniba-volto-persone/components';
import SCHEDA_SVG from '../../theme/images/scheda.svg';
import formatPhoneNumbers from '../Common/formatPhoneNumbers';
import { NavLink } from 'react-router-dom';



const PersonaTemplate = ({
    items,
    title,
    isEditMode,
    linkAlign,
    linkTitle,
    linkHref,
    titleLine,
    linkmore_id_lighthouse,
    page
}) => {
    const intl = useIntl();

    const isMounted = useRef(true);
    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        setOpenModals(items.map(() => false));
    }, [items]);

    const [openModals, setOpenModals] = React.useState(
        items.map(() => false)
    );

    const setOpenModal = (index, value) => {
        if (!isMounted.current) return;
        setOpenModals((prevModals) =>
            prevModals.map((isOpen, i) => (i === index ? value : isOpen))
        );
    };

    const intl_goScheda = intl.formatMessage({ id: 'goRubrica' });
    const intl_goSchedaAlt = intl.formatMessage({ id: 'goRubricaAlt' });
    const intl_goMacrostrutt = intl.formatMessage({ id: 'goMacroStrutt' });
    const intl_goMacrostruttAlt = intl.formatMessage({ id: 'goMacroStruttAlt' });

    return (
        <section className="persone-search-results" aria-label={intl.formatMessage({ id: 'rubricaResultsAlt' }) + page}>
            {title && (
                <Row>
                    <Col>
                        <h2
                            className={cx('mb-4', {
                                'mt-5': !show_block_bg,
                                'title-bottom-line': titleLine,
                            })}
                        >
                            {title}
                        </h2>
                    </Col>
                </Row>
            )}
            <div className="persone-search-results-cards-wrapper mb-3">
                <Row>
                    {items?.map((item, index) => {
                        const fullname = `${item.nome || item.getNome} ${item.cognome || item.getCognome}`;
                        // const [ms_text, ms_path] = item.getMacroStrutturaAfferenzaTitle.split('|').map(s => s.trim());
                        const [ms_text, ms_path] = item.getLiv1StrutturaAfferenzaTitle?.split('|').map(s => s.trim());
                        const telefoniRespResult = item.getTelefonoResp;
                        const { foto: userFoto, placeholder: isDefault } = getUserFoto(item);
                        return (
                            <Col key={item['@id']} xs={12} md={6} lg={4} className="">
                                <Card
                                    className={`listing-item shadow h-auto ${item['review_state']}`}
                                    style={{ maxWidth: '540px' }}
                                    role="region"
                                    aria-labelledby={`card-title-${item.id}`}
                                >
                                    <Row className="g-0 position-relative">
                                        <Col xs={4}>
                                            <img
                                                src={userFoto}
                                                alt={intl.formatMessage({ id: 'schedaPersonaFotoSearchAlt' }, { fullName: fullname })}
                                                title={intl.formatMessage({ id: 'schedaPersonaFotoSearchAlt' }, { fullName: fullname })}
                                                className={`img-fluid rounded-start schedapersona-avatar w-100 ${isDefault ? 'object-fit-contain' : 'object-fit-cover'
                                                    }`}
                                            />
                                        </Col>
                                        <Col xs={8}>
                                            <CardBody className="p-3 h-100 d-flex flex-column justify-content-between">
                                                <div>
                                                    <CardTitle
                                                        id={`card-title-${item.id}`}
                                                        role="heading"
                                                        aria-level="3"
                                                        tag="h5"
                                                        className="p-0 nome-profilo mb-1"
                                                    >
                                                        {fullname}
                                                    </CardTitle>
                                                    <div className="text-primary lh-1 border-bottom border-primary pb-2">
                                                        {/* Nome della U.O. era un link, diventato uno <span> */}
                                                        {
                                                            /* 
                                                                <NavLink
                                                                    to={{
                                                                        pathname: ms_path,  
                                                                        search: "",         
                                                                        hash: "",           
                                                                    }}
                                                                    aria-label={`${intl_goMacrostrutt} : ${ms_text}`}
                                                                    title={`${intl_goMacrostruttAlt} : ${ms_text}`}
                                                                >
                                                                    {ms_text}
                                                                </NavLink> 
                                                            */
                                                        }
                                                        <span>{ms_text}</span>
                                                    </div>
                                                    <div className='z-3 position-relative'>
                                                        <div className="overflow-auto schedapersona-contatti py-2">
                                                            <p className="mail d-flex flex-row align-items-center mb-0">
                                                                <Icon className="d-inline" icon="it-mail" size="sm" aria-hidden="true" />
                                                                <a className="d-inline z-3 position-relative fs-responsive" href={`mailto:${item.email || item.getEmail}`} onClick={e => e.stopPropagation()}>
                                                                    {item.email || item.getEmail}
                                                                </a>
                                                            </p>
                                                            {item.getTelefono?.items?.filter(t => t.principale)?.map((telefono, idx) => (
                                                                <div className="telefono" key={idx}>
                                                                    <p className="d-flex flex-row align-items-center mb-0">
                                                                        <Icon className="d-inline" icon="it-telephone" size="sm" aria-hidden="true" />
                                                                        <a
                                                                            className="d-inline z-3 position-relative fs-responsive"
                                                                            href={`tel:${telefono.telefono}`}
                                                                            onClick={e => e.stopPropagation()}
                                                                        >
                                                                            {formatPhoneNumbers(telefono.telefono)}
                                                                            {telefono.interno && ` int. ${telefono.interno}`}
                                                                            {telefono.indicazioni && ` - ${telefono.indicazioni}`}
                                                                        </a>
                                                                    </p>
                                                                </div>
                                                            ))}
                                                            {item.getTelefono?.items?.length == 0 &&
                                                                telefoniRespResult &&
                                                                Object.values(telefoniRespResult)?.[0]?.items?.map((telefono, index) => (
                                                                    <div className="telefono" key={index}>
                                                                        <p className="d-flex flew-row align-items-center mb-0">
                                                                            <Icon className="d-inline" icon="it-telephone" size="sm" aria-hidden="true" />
                                                                            <a
                                                                                className="d-inline z-3 position-relative fs-responsive"
                                                                                href={`tel:${telefono.telefono}`}
                                                                                onClick={e => e.stopPropagation()}
                                                                            >
                                                                                {formatPhoneNumbers(telefono.telefono)}
                                                                                {telefono.interno && ` int. ${telefono.interno}`}
                                                                                {telefono.indicazioni && ` - ${telefono.indicazioni} (responsabile)`}
                                                                            </a>
                                                                        </p>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <a
                                                        href={item['@id']}
                                                        aria-label={`${intl_goScheda} : ${fullname}`}
                                                        title={`${intl_goSchedaAlt} : ${fullname}`}
                                                        className="stretched-link d-flex flex-row justify-content-end"
                                                        onClick={
                                                            (e) => {
                                                                e.preventDefault();
                                                                setOpenModal(index, true);
                                                            }
                                                        }
                                                    >
                                                        <img
                                                            src={SCHEDA_SVG}
                                                            aria-hidden="true"
                                                            className="icona-scheda object-fit-contain"
                                                        />
                                                    </a>
                                                </div>
                                            </CardBody>
                                        </Col>
                                    </Row>
                                    {openModals[index] && (
                                        <SchedaPersonaModalView
                                            props={item}
                                            startsOpen={openModals[index]}
                                            setOpen={value => setOpenModal(index, value)}
                                        />
                                    )}
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>

            <ListingLinkMore
                title={linkTitle}
                href={linkHref}
                linkAlign={linkAlign}
                className="my-4"
                linkmoreIdLighthouse={linkmore_id_lighthouse}
            />

        </section>
    );
};



PersonaTemplate.propTypes = {
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
    linkTitle: PropTypes.any,
    linkHref: PropTypes.any,
    title: PropTypes.string,
};

export default PersonaTemplate;
